/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import BaseWidget from 'scripts/base-widget';
import can from 'can';
import device from 'scripts/utils/device';
import appConfig from 'scripts/app-config';
import 'components/dfp-advert-unit/dfp-advert-unit';
import 'components/image-cloudinary/image-cloudinary';

const LEGACY_ROTATION_INTERVAL = 7;
const usedBanners = {};

export const DfpAdvertUnit = BaseWidget.extend({
    init: function() {
        if (this.options.legacy && device.isOldIE) {
            this.initLegacy();
        } else {
            this.initDfp();
        }
        this._super();
    },

    initLegacy: function() {
        const type = this.options.legacyType;

        if (!type) {
            return;
        }

        let banners = _.get(appConfig, `legacy-dfp-banners.${type}`);

        if (banners) {
            if (!banners[0]) {
                banners = [banners];
            }

            const banner = _.find(banners, (banner) => {
                return _.get(usedBanners, type, []).indexOf(banner.id) === -1;
            });

            if (!banner) {
                return null;
            }

            if (!usedBanners[type]) {
                usedBanners[type] = [];
            }

            usedBanners[type].push(banner.id);

            this.viewModel = new can.Map({
                banner,
            });

            this.view = can.stache(
                '<a href="{{banner.url}}"><image-cloudinary {id}="banner.image" /></a>',
            );
        }
    },

    initDfp: function() {
        this.viewModel = {
            sizes: this.options.sizes,
            adUnitPath: this.options.adUnitPath,
            reloadInterval: +this.options.reloadInterval,
            responsive: this.options.responsive,
        };
        this.view = can.stache(
            '<dfp-advert-unit reload-interval="{{reloadInterval}}" ad-unit-path="{{adUnitPath}}" {sizes}="sizes" {responsive}="responsive">',
        );
    },
});
